import { Table } from "@mantine/core";

import ClientTableRows from "@/encounters/components/EncounterLabor/EncounterLaborPostpartum/ClientPostpartum/ClientTableRows";
import { usePostpartumObservations } from "@/encounters/components/EncounterLabor/hooks/usePostpartumObservations";
import FlowsheetTable from "@/encounters/components/FlowsheetTable/FlowsheetTable";

export default function ClientPostpartumFlowsheetTable({
  encounterId,
  clientId,
  showNumbersOnly,
  isViewOnly,
}: {
  encounterId: string;
  clientId: string;
  showNumbersOnly: boolean;
  isViewOnly: boolean;
}) {
  // Use the postpartum observations hook and get birthDateTime and refresh function
  const { birthDateTime, refreshObservations } = usePostpartumObservations(encounterId, clientId);

  return (
    <FlowsheetTable>
      <TableHeader />
      <Table.Tbody>
        <ClientTableRows
          key={birthDateTime}
          isViewOnly={isViewOnly}
          onRefresh={refreshObservations}
          showNumbersOnly={showNumbersOnly}
        />
      </Table.Tbody>
    </FlowsheetTable>
  );
}

function TableHeader() {
  return (
    <Table.Thead>
      <Table.Tr styles={{ tr: { borderWidth: "2px" } }}>
        <Table.Th ta="center">Time</Table.Th>
        <Table.Th ta="center">BP</Table.Th>
        <Table.Th ta="center">Temp</Table.Th>
        <Table.Th ta="center">Pulse</Table.Th>
        <Table.Th ta="center">Fundus</Table.Th>
        <Table.Th ta="center">Est. Bleeding</Table.Th>
      </Table.Tr>
    </Table.Thead>
  );
}
